import './App.css';
import './index.css';
import Navbar from './Navbar';
import Herosection from './Herosection';
import Section2 from './section2';
import Section3 from './section3';
import Section4 from './section4';
import Section5 from './section5';
import Section6 from './section6';
import Section7 from './section7';
import Section8 from './section8';
import Contactos from './contactos';
import Aboutos from './aboutos';
import Courseos from './courseos';
import PrivacyPolicy from './privacy-policy'; 
import TermsAndConditions from './terms-and-conditions';
import Blog from './blog';
import BlogDetail from './blog-detail';
import DeleteAccount from './delete-account';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Home Route */}
        <Route
          path='/'
          element={
            <>
              <Herosection />
              <Section2 />
              <Section3 />
              <Section4 />
              <Section5 />
              <Section6 />
              <Section7 />
              <Section8 />
            </>
          }
        />
        {/* Other Routes */}
        <Route
          path='/courses'
          element={
            <>
              <Courseos />
            </>
          }
        />
        <Route path='/blog' element={<Blog />} />
        <Route path='/blog/:slug' element={<BlogDetail />} />
        <Route
          path='/about'
          element={
            <>
              <Aboutos />
            </>
          }
        />
        <Route
          path='/contact'
          element={
            <>
              <Contactos />
            </>
          }
        />
        <Route
          path='/privacy-policy'
          element={
            <>
              <PrivacyPolicy />
            </>
          }
        />
        <Route
          path='/terms-and-conditions'
          element={
            <>
              <TermsAndConditions />
            </>
          }
        />
        <Route
          path='/delete-account'
          element={
            <>
              <DeleteAccount />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
